export default __webpack_public_path__ + "static/media/3piRobot.dd4d9d87.mp4";